// extracted by mini-css-extract-plugin
export default {"field_wrapper":"LocationSearchField_field_wrapper__hsxA4"};